import Vue from 'vue'
import VueRouter from 'vue-router'
import NewsDetailPage from '../views/news-detail/index.vue'
import NewsPage from '../views/news/index.vue'
import ResearchPage from '../views/research/index.vue'
import HomePage from '../views/home/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage
  },
  {
    path: '/home',
    redirect: '/'
  },
  {
    path: '/research',
    name: 'research',
    component: ResearchPage
  },
  {
    path: '/news',
    name: 'news',
    component: NewsPage
  },
  {
    path: '/news-detail',
    name: 'news-detail',
    component: NewsDetailPage
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
